export default __webpack_public_path__ + "static/media/teamPlayer.5b07875d.jpg";